import React from 'react';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { Userpilot } from 'userpilot';

import theme, { ThemeProvider } from '@alpha/ui-lib/theme';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import App from './App';
import awsExports from './aws-exports';
import * as serviceWorker from './serviceWorker';
import { store } from './store';

import 'i18n/config';

Amplify.configure(awsExports);
const queryClient = new QueryClient();

if (process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATA_DOG_APP_ID || '',
    clientToken: process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: process.env.REACT_APP_DATA_DOG_SERVICE,
    env: process.env.REACT_APP_DATA_DOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.REACT_APP_VERSION,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'allow',
    enableExperimentalFeatures: ['clickmap'],
  });

  datadogLogs.init({
    clientToken: process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    service: process.env.REACT_APP_DATA_DOG_SERVICE,
    env: process.env.REACT_APP_DATA_DOG_ENV,
  });
}
datadogRum.startSessionReplayRecording();

Userpilot.initialize(process.env.REACT_APP_USERPILOT_TOKEN || '');

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
